import * as React from 'react';

const CurrencyUsd = (props:any) => (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
        <path d="M13.47 20.328h-1.347v-1.26c-2.91-.175-4.707-1.718-4.717-4.023H9.79c.088 1.094.977 1.875 2.334 2.021v-4.16l-.937-.224c-2.256-.557-3.477-1.885-3.477-3.838 0-2.305 1.66-3.819 4.414-4.053V3.443h1.348v1.348c2.607.234 4.306 1.797 4.355 3.994h-2.334c-.03-1.006-.85-1.806-2.021-1.963v3.955l.966.205c2.481.577 3.663 1.836 3.663 3.897 0 2.422-1.69 3.935-4.63 4.18v1.27zm2.247-5.195c0-1.045-.703-1.67-2.246-1.973v3.926c1.425-.088 2.246-.8 2.246-1.953zM10.12 8.639c0 .937.693 1.582 2.002 1.855V6.813c-1.162.068-2.002.83-2.002 1.826z" />
    </svg>
);

export default CurrencyUsd;

